import { difference, keys, omit, values } from 'lodash';
import { unreachable } from '../../../../ts-utils';
import { getDuplexerSafeValue } from './get-duplexer-safe-value';
export const initSubscriptionsManager = ({ connect, subscribe, }) => {
    let state = { type: 'CLOSED' };
    return {
        syncSubscriptions: (params) => {
            switch (state.type) {
                case 'CLOSED': {
                    if (params.type === 'DISABLED' || params.readyResourceIds.length === 0) {
                        return;
                    }
                    const connection = connect();
                    const subscriptions = subscribe(connection, params.readyResourceIds);
                    state = { type: 'OPEN', subscriptions, connection };
                    return;
                }
                case 'OPEN': {
                    const { connection, subscriptions } = state;
                    if (params.type === 'DISABLED' || params.readyResourceIds.length === 0) {
                        values(subscriptions).forEach((s) => s.unsubscribe());
                        connection.disconnect();
                        state = { type: 'CLOSED' };
                        return;
                    }
                    const toSubscribeIds = difference(params.readyResourceIds, keys(subscriptions));
                    const newSubscription = subscribe(connection, toSubscribeIds);
                    const toUnsubscribeIds = difference(keys(subscriptions), params.readyResourceIds);
                    toUnsubscribeIds.map((id) => subscriptions[id]).forEach((s) => s.unsubscribe());
                    state = {
                        type: 'OPEN',
                        subscriptions: { ...omit(subscriptions, toUnsubscribeIds), ...newSubscription },
                        connection,
                    };
                    return;
                }
                default:
                    unreachable(state);
            }
        },
        publishIAmTyping: (resourceId) => {
            if (state.type === 'CLOSED') {
                return;
            }
            const subscription = state.subscriptions[resourceId];
            if (!subscription) {
                return;
            }
            subscription.publishIAmTyping();
        },
    };
};
export const subscribe = ({ getState, emitCommentCreatedTo: emitCommentCreated, emitTypingTo: emitTyping, appDefId, onDuplexerError, }) => (connection, resourceIds) => {
    connection.on('@duplexer:connect_error', onDuplexerError);
    return resourceIds.reduce((acc, resourceId) => {
        const resourceState = getState().comments[resourceId];
        if (resourceState?.type !== 'READY') {
            return acc;
        }
        const channel = connection.subscribe(generateChannelName({
            appDefId,
            contextId: getDuplexerSafeValue(resourceState.configs.ctxFields.contextId),
            name: 'comments',
        }), {
            resourceId: getDuplexerSafeValue(resourceId),
        });
        channel.on('comment-created', emitCommentCreated);
        channel.on('@duplexer:subscription_failed', onDuplexerError);
        channel.on('client-typing', () => {
            emitTyping(resourceId);
        });
        acc[resourceId] = {
            unsubscribe: () => {
                channel.unsubscribe();
            },
            publishIAmTyping: () => {
                channel
                    .send('client-typing', 
                // secretly required by duplexer...
                {})
                    .catch(onDuplexerError);
            },
        };
        return acc;
    }, {});
};
export function generateChannelName({ name, appDefId, contextId, }) {
    return [name, appDefId, contextId].join('---');
}
//# sourceMappingURL=live-updates-subscriptions.js.map